const template = `<page-content v-if="componentKey > 0"></page-content>`;

export default {
	template,
	data() {
		return {
			componentKey: 0
		};
	},
	methods: {
		loadComponent() {
			Vue.component('page-content', async() => {
				this.app.isLoading = true;
				
				let file = this.$route.meta.file || this.$route.path.split('/')[2];
				let ver = window.assetVer ? '&v=' + window.assetVer : '';
				let url = '/ecma/pages/' + file + '.js?format=amd' + ver;
				let res = await this.loader.loadScript(url, true, 'page-script');

				if (res._cssUrl !== null) {
					let cssUrl = res._cssUrl || '/less/pages/' + file + '.min.css' + (ver ? '?' + ver.slice(1) : '');
					await this.loader.loadStyle(cssUrl, true).catch(err => {});
				}

				document.body.setAttribute('data-page', file);

				this.app.isLoading = false;
				return res;
			});
			this.componentKey++;
		}
	},
	watch: {
		'$route.meta.file'() {
			this.loadComponent();
		}
	},
	mounted() {
		this.loadComponent();
	}
}